import { useAuth } from "./use-auth";

export const useContractPermissions = () => {
  const { user } = useAuth();

  const canManageContract = (employeeId = null) => {
    // Admin and HR can manage all contracts
    if (user?.role === "admin" || user?.role === "rh") {
      return true;
    }
    return false;
  };

  const canViewContract = (employeeId = null) => {
    // Admin and HR can view all contracts
    if (user?.role === "admin" || user?.role === "rh") {
      return true;
    }

    // Managers can view their team's contracts
    if (user?.role === "manager") {
      return true;
    }

    // Employees can only view their own contract
    if (employeeId && user?.id === employeeId) {
      return true;
    }

    return false;
  };

  const canUploadContract = (employeeId = null) => {
    // Only admin and HR can upload contracts
    return user?.role === "admin" || user?.role === "rh";
  };

  const canDeleteContract = (employeeId = null) => {
    // Only admin and HR can delete contracts
    return user?.role === "admin" || user?.role === "rh";
  };

  const canDownloadContract = (employeeId = null) => {
    return canViewContract(employeeId);
  };

  return {
    canManageContract,
    canViewContract,
    canUploadContract,
    canDeleteContract,
    canDownloadContract,
  };
};
